module.exports = "/images/extra-car.svg?2edd2da74df9e596fedd2d843db8cf67";